module.exports = __webpack_public_path__ + "static/media/about-certified.48275ef9.png";